import { FaqItem } from "@/components/screen/global-components/faq/FaqStack";

export const faqItems: FaqItem[] = [
  {
    id: "item-1",
    title: "What is a translate affiliate program?",
    description: [
      "Generally an affiliate program is a partnership model where you or your business can earn a commission by promoting and referring customers to another businesses products or services.",
      "Languex translate affiliate program is a free program you can sign up for to receive a custom tracking link that you would use to promote Languex’s services and share on your website, blog, social media, email or other channels. You receive a 25% revenue share based on the traffic you refer to us, without any limits on the number of referrals you can earn.",
      "Email our support team with your name, business, and interest to signup and get your tracking link.",
    ],
    linkText: "Join now",
    link: "#",
  },
  {
    id: "item-2",
    title: "Who should join the affiliate translate program?",
    description: [
      "Any bloggers, content creators, website owners or other businesses who cater to relevant audiences that might be interested in high-quality certified or standard professional translations would be a great candidate for our affiliate program.",
      "There are no restrictions on who can join the program as long as you have an audience you think will benefit from our translation services.",
      "Ready to become an affiliate or have any questions? Email our support team and we’ll get back to you within 24-hours or less.",
    ],
    linkText: "Learn more",
    link: "#",
  },
  {
    id: "item-3",
    title: "Will I earn a commission on people who convert after a long time?",
    description: [
      "Yes. If you refer a customer to us via a tracking link and that customer requests a quote but does not make an order right away, you will still earn a commission on their future order should they make an order within the 100-day referral window.",
      "Ready to become an affiliate or have any questions? Email our support team and we’ll get back to you within 24-hours or less.",
    ],
    linkText: "See all",
    link: "#",
  },
  {
    id: "item-4",
    title:
      "How and when do I get paid as part of the affiliate translate program?",
    description: [
      "Payouts happen monthly via PayPal. <br/>Ready to become an affiliate or have any questions? Email our support team and we’ll get back to you within 24-hours or less.",
    ],
    linkText: "Join now",
    link: "#",
  },
  {
    id: "item-5",
    title: "Are there any restrictions in your affiliate program?",
    description: [
      "We encourage our affiliate translate program members to write about or reference Languex on their websites, in blogs, on social media, in logos and banners on websites, via email or newsletters, in videos and within other content you create.",
      "However, we don’t approve use of the tracking links within paid advertising, any false advertising of Languex’ services, for your own purchases, by offering unofficial discounts or coupon codes, or on discount/coupon websites.",
      "Ready to become an affiliate or have any questions? Email our support team and we’ll get back to you within 24-hours or less.",
    ],
    linkText: "See all",
    link: "#",
  },
];
